import React from 'react';

function Mobile_footer() {
    return (
        <div id="mobile_footer">
            <a href="sms:510-736-3779" className='subtext'>510-736-3779 (Text only)</a>
            <a href="https://www.google.com/maps/place/Lush+Eye+Bar/@37.7646718,-122.2403087,15z/data=!4m5!3m4!1s0x0:0x243d25c8e01b0637!8m2!3d37.7646718!4d-122.2403087" target="_blank" rel="noopener noreferrer">2447 Santa Clara Ave #103, Alameda, CA 94501</a>
        </div>
    )
}

export default Mobile_footer;
